import { projectDeliveredKey } from 'root/src/shared/constants/keys'
import {
	ADD_FEATURED_DARE,
} from 'root/src/shared/descriptions/endpoints/endpointIds'

import {
	APPROVE_AND_FEATURE_DARE,
} from 'root/src/shared/descriptions/recordClickActions/recordClickActionIds'
import { PENDING_DELIVERIES_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'

export default {
	[APPROVE_AND_FEATURE_DARE]: {
		endpointId: ADD_FEATURED_DARE,
		payloadMap: [
			['projectUrl', { $sub: ['recordId'] }],
			['approveDelivery', true],
		],
		label: 'Approve & Feature',
		onSuccessRecordUpdates: [
			{
				modification: 'set',
				path: ['project', ':recordStoreKey', 'status'],
				value: projectDeliveredKey,
			},
		],
		onSuccessRedirect: { routeId: PENDING_DELIVERIES_ROUTE_ID },
	},
}
